export default {
  header: 'Stock by product',
  release: 'Release',
  empty: 'No AGP records.',
  product: 'Product',
  bottleSize: 'Bottle size',
  inAgp: 'In AGP',
  bottled: 'Bottled',
  released: 'Released',
  batches: 'Batches',
  emptyBatch: 'empty',
};
